module.exports = __webpack_public_path__ + "staticPO/img/Logoa.0ffc1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Login/Logoa.png
// module id = aDdh
// module chunks = 1